import { Form } from 'react-bootstrap'

export default function MultiFile(props) {

    const { label_name, disabled, name, onChange, onBlur, error, accept, mandatory, reference, tabIndex } = props

    return (
        <>
            <Form.Group className="mb-2" controlId="multi-file">
                <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{label_name}</Form.Label>
                <Form.Control
                    ref={reference}
                    type="file"
                    multiple="multiple"
                    size="sm"
                    disabled={disabled}
                    className='form_input'
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    accept={accept}
                    tabIndex={tabIndex}
                />
                {error}
            </Form.Group>
        </>
    )
}
